export const registerYoutubeVideosLoader = () => {
  // This function loads the IFrame Player API code asynchronously.
  function loadYouTubeIframeAPI() {
    var tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  }

  function onYouTubeIframeAPIReady() {
    const youtubeAllVideos = document.querySelectorAll('.youtube-video')

    youtubeAllVideos.forEach((video, index) => {
      new YT.Player(video, {
        height: '100%',
        width: '100%',
        videoId: `${video.dataset.videoId}`,
        events: {
          onReady: onPlayerReady,
        },
      })
    })
  }

  function onPlayerReady(e) {
    const currentPlayerElement = e.target.g
    const thumbnail = currentPlayerElement.nextElementSibling
    thumbnail.addEventListener('click', () => {
      currentPlayerElement.classList.remove('opacity-0')
      e.target.playVideo()
      thumbnail.style = 'display: none'
    })
  }

  // Load the IFrame Player API code asynchronously.
  loadYouTubeIframeAPI()

  // Make the function globally available
  window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady
}
